import { useEffect, useState } from "react";
import { UseFormReturn, useWatch } from "react-hook-form";
import { WidgetConfig } from "../Conversation";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
import styles from "../MinimizedWidget/minimizedwidget.module.css";
import { FormInputProps } from "@components/WAChatbutton/WAform/WidgetForm";

interface MinimizedWidgetProps {
    control: UseFormReturn<FormInputProps>["control"];
}

const MinimizedWidget: React.FC<MinimizedWidgetProps> = ({ control }) => {
    const data = useWatch<FormInputProps>({ control });
    const [mappedData, setMappedData] = useState<WidgetConfig>();
    useEffect(() => {
        if (!data) {
            return;
        }
        const {
            brandName,
            statusTag,
            wanumber,
            welcomeText,
            triggerMsg,
            question,
            buttonPosition,
            logo,
            options,
            startChatBtnTxt,
            customQuestion,
            widgetPositionMarginX,
            widgetPositionMarginY,
            widgetStyle,
        } = data as FormInputProps;

        const config: WidgetConfig = {
            waId: wanumber,
            siteName: brandName || "Gallabox",
            siteTag: statusTag || "usually reply with in a day",
            siteLogo: logo,
            widgetPosition: buttonPosition !== "RIGHT" ? "LEFT" : "RIGHT",
            triggerMessage: triggerMsg,
            welcomeMessage: welcomeText || "Welcome to Gallbox. Enable engaging-converstation",
            messageText: question || "Ask you questions? I am looking for ",
            replyOptions: options?.map((o: { content: string }) => o.content),
            customQuestion: customQuestion,
            startChatBtnTxt: startChatBtnTxt,
            widgetStyle: widgetStyle,
            widgetPositionMarginX: widgetPositionMarginX,
            widgetPositionMarginY: widgetPositionMarginY,
        };
        setMappedData(config);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(data)]);

    return (
        <div className={mappedData?.widgetPosition == "RIGHT" ? styles.bconcontainerbodyright : styles.bconcontainerbodyleft}>
            <div className={styles.bconcontainer}>
                <button aria-label="minimized button" disabled style={{ backgroundColor: "#25D366" }}>
                    <span>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M0 24L1.69523 17.8375C0.649542 16.0339 0.0995157 13.988 0.100284 11.8919C0.102974 5.33476 5.46337 0 12.0502 0C15.2467 0.00133872 18.2469 1.23984 20.5031 3.48772C22.7591 5.73561 24.0012 8.7236 24 11.9015C23.9971 18.4585 18.6359 23.794 12.0502 23.794C12.0499 23.794 12.0504 23.794 12.0502 23.794H12.0451C10.0451 23.7933 8.08018 23.2939 6.33481 22.3463L0 24ZM6.62817 20.1935L6.99107 20.4075C8.5157 21.3082 10.2638 21.7846 12.0464 21.7856H12.0502C17.5244 21.7856 21.9799 17.351 21.9822 11.9007C21.9832 9.25947 20.9511 6.77578 19.0759 4.90752C17.2005 3.03925 14.707 2.00979 12.0539 2.00864C6.57534 2.00864 2.11999 6.44264 2.11788 11.8927C2.11711 13.7604 2.64197 15.5791 3.63636 17.1531L3.87266 17.5271L2.86905 21.1746L6.62817 20.1935Z"
                                fill="white"
                            />
                            <path
                                d="M9.05102 6.55751C8.8299 6.02745 8.59701 6.0168 8.38653 6.00758C8.21442 5.99959 8.01742 6 7.82081 6C7.62401 6 7.30411 6.07988 7.0336 6.39837C6.7629 6.71686 6 7.48696 6 9.05318C6 10.6196 7.0581 12.133 7.20571 12.3456C7.35331 12.558 9.24821 15.8747 12.2491 17.1507C14.7431 18.2113 15.2505 18.0003 15.7919 17.9473C16.3333 17.8942 17.5386 17.1772 17.7846 16.4339C18.0308 15.6906 18.0308 15.0536 17.9569 14.9203C17.883 14.7878 17.6862 14.7081 17.391 14.549C17.0958 14.3898 15.6443 13.6195 15.3736 13.5134C15.1029 13.4071 14.9061 13.3543 14.7093 13.673C14.5123 13.9913 13.947 14.7081 13.7747 14.9203C13.6024 15.1331 13.4301 15.1597 13.1349 15.0004C12.8397 14.8408 11.8887 14.5049 10.7607 13.4204C9.88307 12.5768 9.29038 11.5347 9.11808 11.216C8.94597 10.8977 9.11523 10.7404 9.24783 10.5666C9.48661 10.2534 9.88725 9.69036 9.98565 9.47817C10.0841 9.26557 10.0348 9.0798 9.96114 8.92046C9.88725 8.76132 9.31336 7.18711 9.05102 6.55751Z"
                                fill="white"
                            />
                        </svg>
                    </span>
                </button>
                <div className={styles.notificationbadge}>1</div>
            </div>
            {mappedData?.triggerMessage && (
                <div className={styles.bconwelcomemessagecontainer}>
                    <div className={mappedData?.widgetPosition == "RIGHT" ? styles.welcomemessage : styles.welcomemessageleft}>{mappedData?.triggerMessage}</div>
                </div>
            )}
        </div>
    );
};

export default MinimizedWidget;
